// ⚠ AUTO-GENERATED FILE – DO NOT EDIT MANUALLY

import type { ComponentType } from "react";

import { Briefcase, CalendarDays, Dumbbell, FolderTree, HeartPulse, Landmark, Martini, Mountain, Palette, Plane, ShoppingBag, UtensilsCrossed } from "lucide-react";

export const categoryIconMap: Record<string, ComponentType<any>> = {
  "briefcase": Briefcase,
  "calendar-days": CalendarDays,
  "dumbbell": Dumbbell,
  "folder-tree": FolderTree,
  "heart-pulse": HeartPulse,
  "landmark": Landmark,
  "martini": Martini,
  "mountain": Mountain,
  "palette": Palette,
  "plane": Plane,
  "shopping-bag": ShoppingBag,
  "utensils-crossed": UtensilsCrossed,
};
